// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"a22d226e","703":"2d0ed6c2","787":"ba2db99b"}[chunkId] + ".chunk.js";
};